import { Field, RawInput as Input } from '@payaca/ambrosia';
import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { fieldProps } from './DynamicField';
import { meterNumberType } from './utils/reactHookForm';

export const MeterNumberInputField: FC<{
  name: string;
  fieldSchema: any;
  helperText: string;
  registerProps: any;
}> = ({ name, fieldSchema, helperText, registerProps }) => {
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext();
  const address = useWatch({
    control,
    name: 'installerCustomerDetails.mainAddress',
  });
  const postcode = address?.postcode as string | undefined;
  const fieldIdentifier = meterNumberType(postcode || '');

  return (
    <Field.Legacy {...fieldProps(errors, name)}>
      <Field.Label>{fieldIdentifier}</Field.Label>
      <Field.HelperText>{helperText}</Field.HelperText>
      <Input
        type={fieldSchema.type}
        placeholder={`Enter customer's ${fieldIdentifier}`}
        {...register(name, registerProps)}
      />
    </Field.Legacy>
  );
};
